import { render, staticRenderFns } from "./LanguageSelector.vue?vue&type=template&id=5b55cfa7&scoped=true&"
import script from "./LanguageSelector.vue?vue&type=script&lang=js&"
export * from "./LanguageSelector.vue?vue&type=script&lang=js&"
import style0 from "./LanguageSelector.vue?vue&type=style&index=0&id=5b55cfa7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b55cfa7",
  null
  
)

component.options.__file = "LanguageSelector.vue"
export default component.exports